/* AUTH */
export const SET_ADDRESS = "SET_ADDRESS";
export const SET_NETWORKID = "SET_NETWORKID";
export const SET_ERROR = "SET_ERROR";

export * from "./auth/actions";
